import axios from 'axios';
import config from '../config';

const headers = {
  'Content-Type': 'application/json',
  'Authorization':
      'Bearer MXIzVURjamdOSU9QejVkbjZla01QTmFGTEtkcHdROE9HOHhoYjJ0RQ==',
};

const apiRequest = async ({method, endpoint, params = {}}) => {
  method = method.toUpperCase();
  const {data} = await axios({
    method,
    url: `${config.APP_URL}${endpoint}`,
    headers,
    params: method === 'GET' ? params : {},
    data: method !== 'GET' ? params : {},
  });
  return data;
};

export default apiRequest;
